import Address from 'assets/images/psp/FindStorageNearYou/Address.svg';

export const StorageNearYouData = {
	title: 'Find Storage Near You',
	image: Address,
	nearByDetectedCities: {
		title: 'Storage facilities in ',
		cities: [],
	},
	citiesByState: {
		title: 'Storage facilities in ',
		cities: [],
	},
	statesLink: {
		title: 'Storage facilities across the country',
		cities: [
			{
				slug: '/Los-Angeles-CA-self-storage.html',
				name: 'Los Angeles, CA',
			},
			{
				slug: '/New-York-NY-self-storage.html',
				name: 'New York, NY',
			},

			{
				slug: '/Chicago-IL-self-storage.html',
				name: 'Chicago, IL',
			},

			{
				slug: '/Houston-TX-self-storage.html',
				name: 'Houston, TX',
			},
			{
				slug: '/San-Diego-CA-self-storage.html',
				name: 'San Diego, CA',
			},
			{
				slug: '/Phoenix-AZ-self-storage.html',
				name: 'Phoenix, AZ',
			},
			{
				slug: '/Philadelphia-PA-self-storage.html',
				name: 'Philadelphia, PA',
			},
			{
				slug: '/Washington-DC-self-storage.html',
				name: 'Washington, DC',
			},
			{
				slug: '/Austin-TX-self-storage.html',
				name: 'Austin, TX',
			},
			{
				slug: '/Dallas-TX-self-storage.html',
				name: 'Dallas, TX',
			},
		],
	},
};